import React, { useState, useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Container, Message, Loader } from 'semantic-ui-react';
import axios from '../../config/axios';

const MasterRoute = ({ children, ...rest }) => {
  const [loading, setLoading] = useState(true);
  const [isMaster, setIsMaster] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkMasterRole = async () => {
      try {
        const cacheKey = 'bdc_access_ok';
        const tsKey = 'bdc_access_checked_at';
        const lastOk = sessionStorage.getItem(cacheKey);
        const lastTs = Number(sessionStorage.getItem(tsKey) || 0);
        const TTL = 5 * 60 * 1000; // 5 minutos
        if (lastOk === 'true' && Date.now() - lastTs < TTL) {
          setIsMaster(true);
          return;
        }

        await axios.get('/v3/admin/units-management/test-access');
        sessionStorage.setItem(cacheKey, 'true');
        sessionStorage.setItem(tsKey, String(Date.now()));
        setIsMaster(true);
      } catch (err) {
        if (err.response && err.response.status === 403) {
          setIsMaster(false);
          const code = err.response?.data?.code;
          if (code === 'BIGDATACORP_ACCESS_DENIED') {
            setError('Acesso negado: seu usuário não está autorizado para operações BigDataCorp.');
          } else {
            setError('Acesso negado. Esta funcionalidade requer perfil autorizado para BigDataCorp.');
          }
        } else {
          setError('Erro ao verificar permissões. Tente novamente.');
        }
      } finally {
        setLoading(false);
      }
    };

    checkMasterRole();
  }, []);

  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (loading) {
          return (
            <Container style={{ padding: '60px 0' }}>
              <Loader active inline="centered">
                Verificando permissões...
              </Loader>
            </Container>
          );
        }

        if (error) {
          return (
            <Container style={{ padding: '60px 20px' }}>
              <Message negative>
                <Message.Header>Acesso Restrito</Message.Header>
                <p>{error}</p>
              </Message>
            </Container>
          );
        }

        if (!isMaster) {
          return <Redirect to={{ pathname: '/', state: { from: location } }} />;
        }

        return children;
      }}
    />
  );
};

export default MasterRoute;